import { webapi } from '@/api/webapi.ts';
import { cancelCallOrder } from '@/store/orders/call/api/cancelCallOrder.ts';
import { submitCallOrder } from '@/store/orders/call/api/submitCallOrder.ts';
import { updateCallOrder } from '@/store/orders/call/api/updateCallOrder.ts';
import { validateCallOrder } from '@/store/orders/call/api/validateCallOrder.ts';

export const callOrderApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    validateCallOrder: validateCallOrder(builder),
    submitCallOrder: submitCallOrder(builder),
    updateCallOrder: updateCallOrder(builder),
    cancelCallOrder: cancelCallOrder(builder),
  }),
});

export const {
  useValidateCallOrderMutation,
  useSubmitCallOrderMutation,
  useUpdateCallOrderMutation,
  useCancelCallOrderMutation,
} = callOrderApi;
